import React from "react";
import * as IoIcons from "react-icons/io";
import CerrarSesion from "./CerrarSesion";

export const getSidebarDataAdmin = (correo) => [
  {
    title: correo || "Usuario",
    type: "profile",
    icon: <IoIcons.IoIosPerson />,
  },
  {
    title: "Gestión Usuarios",
    path: "/InfoUsuarios",
    icon: <IoIcons.IoIosPeople />,
  },
  {
    title: "Reportes",
    path: `/InfoReportes/${correo}`,
    icon: <IoIcons.IoIosMap />,
  },
  {
    title: "Permisos",
    path: "/InfoPermisos",
    icon: <IoIcons.IoIosPaper />,
  },
  {
    title: "",
    type: "logout",
    icon: <CerrarSesion />,
  },
];
